<template>
    <div>
        <section>
            <div class="inner row5">
                <div class="title">
                    <h1>FAQ 관리</h1>
                </div>
                <section>
                    <div class="row4">
                        <div class="btnBox blankLeft">
                            <button class="blueBtn smBtn" @click="updateFaq">수정</button>
                            <button class="orangeBtn smBtn" @click="deleteBtn">삭제</button>
                        </div>
                        <hr class="hrNotice">
                        <div class="noticeWriteContainer">
                            <div class="headTxtContain flex flexAlignS">
                                <p>
                                    <span class="QIcon"></span>
                                    {{ question }}
                                </p>
                                <div class="subDateContain">
                                    <p>
                                        <span>
                                            <strong>
                                                등록일
                                            </strong>
                                        </span>
                                        <span>
                                            {{ regDate }}
                                        </span>
                                    </p>
                                </div>
                            </div>
                            
                            <div class="textAreaContain">
                                <div class="noticeTxtBox">
                                    <span class="AIcon"></span>
                                    <div v-html="answer"></div>
                                </div>
                            </div>
                            <div class="subBtnContain flex flexAlignS">
                                <a href="#" @click="listViewBtn()">목록</a>
                                <div class="prevNextBtnContain">
                                    <a href="#" @click="goPrev" v-if="prevFaq">이전글</a>
                                    <a href="#" @click="goNext" v-if="nextFaq">다음글</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        </section>
    </div>   
</template>

<script>
import axios from '@/axios/axios'

export default {
    name: 'Home',
    data() {
        return {
            idx : this.$route.params.idx,
            question: '',
            answer: '',
            regDate: '',
            prevFaq: null,
            nextFaq: null,
            searchText : ''
        }
    },
    created() {
        this.detailFaqInfo();
    },
    watch: {
        '$route': 'detailFaqInfo'
    },
    methods:{
        goback(){
            this.$router.go(-1) 
        },
        listViewBtn() {
            this.$router.push({ path : '/FAQ', query: { searchText : this.searchText }});
        },
        detailFaqInfo(){
            this.searchText = this.$route.params.searchText;
            let param = {
                IDX : this.$route.params.idx,
                SEARCH_TEXT : this.searchText
            };

            axios.post('/api/admin/faq/getFaqInfo', param)
            .then(response => {
                if(response.status == 200){
                    let faq = response.data.FAQ;
                    this.question = faq.QUESTION;
                    this.answer = faq.ANSWER.replace(/(?:\r\n|\r|\n)/g, '<br />');
                    this.regDate = faq.REGDATE;

                    this.prevFaq = response.data.PREV_FAQ;
                    this.nextFaq = response.data.NEXT_FAQ;
                }
            })
            .catch(() => {
            })
            .then(() => {
            });
       },
       goPrev(){
           let idx = this.prevFaq.IDX;
           this.$router.push({ name:'fAQManagementDetail', params: { idx: idx }});
       },
       goNext(){
           let idx = this.nextFaq.IDX;
           this.$router.push({ name:'fAQManagementDetail', params: { idx: idx }});
       },
       updateFaq(){
           this.$router.push({ name:'fAQManagementWrite', params: { idx: this.idx }});
       },
       deleteBtn(){
            let paramDatas = { idx : this.idx };
            axios.post('/api/admin/faq/delete', paramDatas)
            .then(result => {
                if(result.status == 200){
                    this.$alert("알림", "FAQ글이 삭제되었습니다.", "", {
                        'closed': () => {
                            this.listViewBtn();
                        }
                    });
                }
                else {
                    this.$alert("알림", "FAQ글 삭제에 실패하였습니다.");
                }
            })
            .catch((error) => {
                this.$alert("알림", "FAQ글 삭제 중 에러가 발생했습니다. 관리자에게 문의해주세요. <br>"+error);
            });
        }
    }
}
</script>

<style scoped>
    .hrNotice {
        margin: 10px 0 0 0;
    }
</style>